module.exports = __webpack_public_path__ + "static/media/bg2.925d21de.png";